package com.example.monetix.db

import app.cash.sqldelight.Query
import app.cash.sqldelight.SuspendingTransacterImpl
import app.cash.sqldelight.db.SqlDriver
import kotlin.Any
import kotlin.Boolean
import kotlin.Long
import kotlin.String

public class TransactionQueries(
  driver: SqlDriver,
) : SuspendingTransacterImpl(driver) {
  public fun <T : Any> getAllTransactions(mapper: (
    id: String,
    accountId: String?,
    toAccountId: String?,
    fromAccountId: String?,
    amountCents: Long,
    type: String,
    dateEpochDay: Long,
    categoryId: String,
    description: String?,
    merchantKey: String?,
    subcategoryText: String?,
    logoEmoji: String?,
    logoUri: String?,
    isHidden: Boolean,
    isDeleted: Boolean,
    reminderDays: Long?,
    createdAtEpochMs: Long,
    updatedAtEpochMs: Long,
  ) -> T): Query<T> = Query(-439_252_123, arrayOf("TransactionEntity"), driver, "Transaction.sq",
      "getAllTransactions",
      "SELECT TransactionEntity.id, TransactionEntity.accountId, TransactionEntity.toAccountId, TransactionEntity.fromAccountId, TransactionEntity.amountCents, TransactionEntity.type, TransactionEntity.dateEpochDay, TransactionEntity.categoryId, TransactionEntity.description, TransactionEntity.merchantKey, TransactionEntity.subcategoryText, TransactionEntity.logoEmoji, TransactionEntity.logoUri, TransactionEntity.isHidden, TransactionEntity.isDeleted, TransactionEntity.reminderDays, TransactionEntity.createdAtEpochMs, TransactionEntity.updatedAtEpochMs FROM TransactionEntity WHERE isDeleted = 0 ORDER BY dateEpochDay DESC") {
      cursor ->
    mapper(
      cursor.getString(0)!!,
      cursor.getString(1),
      cursor.getString(2),
      cursor.getString(3),
      cursor.getLong(4)!!,
      cursor.getString(5)!!,
      cursor.getLong(6)!!,
      cursor.getString(7)!!,
      cursor.getString(8),
      cursor.getString(9),
      cursor.getString(10),
      cursor.getString(11),
      cursor.getString(12),
      cursor.getBoolean(13)!!,
      cursor.getBoolean(14)!!,
      cursor.getLong(15),
      cursor.getLong(16)!!,
      cursor.getLong(17)!!
    )
  }

  public fun getAllTransactions(): Query<TransactionEntity> = getAllTransactions { id, accountId,
      toAccountId, fromAccountId, amountCents, type, dateEpochDay, categoryId, description,
      merchantKey, subcategoryText, logoEmoji, logoUri, isHidden, isDeleted, reminderDays,
      createdAtEpochMs, updatedAtEpochMs ->
    TransactionEntity(
      id,
      accountId,
      toAccountId,
      fromAccountId,
      amountCents,
      type,
      dateEpochDay,
      categoryId,
      description,
      merchantKey,
      subcategoryText,
      logoEmoji,
      logoUri,
      isHidden,
      isDeleted,
      reminderDays,
      createdAtEpochMs,
      updatedAtEpochMs
    )
  }

  public fun <T : Any> getDeletedTransactions(mapper: (
    id: String,
    accountId: String?,
    toAccountId: String?,
    fromAccountId: String?,
    amountCents: Long,
    type: String,
    dateEpochDay: Long,
    categoryId: String,
    description: String?,
    merchantKey: String?,
    subcategoryText: String?,
    logoEmoji: String?,
    logoUri: String?,
    isHidden: Boolean,
    isDeleted: Boolean,
    reminderDays: Long?,
    createdAtEpochMs: Long,
    updatedAtEpochMs: Long,
  ) -> T): Query<T> = Query(-644_690_339, arrayOf("TransactionEntity"), driver, "Transaction.sq",
      "getDeletedTransactions",
      "SELECT TransactionEntity.id, TransactionEntity.accountId, TransactionEntity.toAccountId, TransactionEntity.fromAccountId, TransactionEntity.amountCents, TransactionEntity.type, TransactionEntity.dateEpochDay, TransactionEntity.categoryId, TransactionEntity.description, TransactionEntity.merchantKey, TransactionEntity.subcategoryText, TransactionEntity.logoEmoji, TransactionEntity.logoUri, TransactionEntity.isHidden, TransactionEntity.isDeleted, TransactionEntity.reminderDays, TransactionEntity.createdAtEpochMs, TransactionEntity.updatedAtEpochMs FROM TransactionEntity WHERE isDeleted = 1 ORDER BY updatedAtEpochMs DESC") {
      cursor ->
    mapper(
      cursor.getString(0)!!,
      cursor.getString(1),
      cursor.getString(2),
      cursor.getString(3),
      cursor.getLong(4)!!,
      cursor.getString(5)!!,
      cursor.getLong(6)!!,
      cursor.getString(7)!!,
      cursor.getString(8),
      cursor.getString(9),
      cursor.getString(10),
      cursor.getString(11),
      cursor.getString(12),
      cursor.getBoolean(13)!!,
      cursor.getBoolean(14)!!,
      cursor.getLong(15),
      cursor.getLong(16)!!,
      cursor.getLong(17)!!
    )
  }

  public fun getDeletedTransactions(): Query<TransactionEntity> = getDeletedTransactions { id,
      accountId, toAccountId, fromAccountId, amountCents, type, dateEpochDay, categoryId,
      description, merchantKey, subcategoryText, logoEmoji, logoUri, isHidden, isDeleted,
      reminderDays, createdAtEpochMs, updatedAtEpochMs ->
    TransactionEntity(
      id,
      accountId,
      toAccountId,
      fromAccountId,
      amountCents,
      type,
      dateEpochDay,
      categoryId,
      description,
      merchantKey,
      subcategoryText,
      logoEmoji,
      logoUri,
      isHidden,
      isDeleted,
      reminderDays,
      createdAtEpochMs,
      updatedAtEpochMs
    )
  }

  public suspend fun upsert(
    id: String,
    accountId: String?,
    toAccountId: String?,
    fromAccountId: String?,
    amountCents: Long,
    type: String,
    dateEpochDay: Long,
    categoryId: String,
    description: String?,
    merchantKey: String?,
    subcategoryText: String?,
    logoEmoji: String?,
    logoUri: String?,
    isHidden: Boolean,
    isDeleted: Boolean,
    reminderDays: Long?,
    createdAtEpochMs: Long,
    updatedAtEpochMs: Long,
  ) {
    driver.execute(-89_324_364, """
        |INSERT OR REPLACE INTO TransactionEntity(id, accountId, toAccountId, fromAccountId, amountCents, type, dateEpochDay, categoryId, description, merchantKey, subcategoryText, logoEmoji, logoUri, isHidden, isDeleted, reminderDays, createdAtEpochMs, updatedAtEpochMs)
        |VALUES (?, ?, ?, ?, ?, ?, ?, ?, ?, ?,?, ?, ?, ?, ?, ?, ?, ?)
        """.trimMargin(), 18) {
          bindString(0, id)
          bindString(1, accountId)
          bindString(2, toAccountId)
          bindString(3, fromAccountId)
          bindLong(4, amountCents)
          bindString(5, type)
          bindLong(6, dateEpochDay)
          bindString(7, categoryId)
          bindString(8, description)
          bindString(9, merchantKey)
          bindString(10, subcategoryText)
          bindString(11, logoEmoji)
          bindString(12, logoUri)
          bindBoolean(13, isHidden)
          bindBoolean(14, isDeleted)
          bindLong(15, reminderDays)
          bindLong(16, createdAtEpochMs)
          bindLong(17, updatedAtEpochMs)
        }.await()
    notifyQueries(-89_324_364) { emit ->
      emit("TransactionEntity")
    }
  }

  public suspend fun softDelete(updatedAtEpochMs: Long, id: String) {
    driver.execute(629_849_978,
        """UPDATE TransactionEntity SET isDeleted = 1, updatedAtEpochMs = ? WHERE id = ?""", 2) {
          bindLong(0, updatedAtEpochMs)
          bindString(1, id)
        }.await()
    notifyQueries(629_849_978) { emit ->
      emit("TransactionEntity")
    }
  }

  public suspend fun setHidden(
    isHidden: Boolean,
    updatedAtEpochMs: Long,
    id: String,
  ) {
    driver.execute(-804_937_977,
        """UPDATE TransactionEntity SET isHidden = ?, updatedAtEpochMs = ? WHERE id = ?""", 3) {
          bindBoolean(0, isHidden)
          bindLong(1, updatedAtEpochMs)
          bindString(2, id)
        }.await()
    notifyQueries(-804_937_977) { emit ->
      emit("TransactionEntity")
    }
  }

  public suspend fun deleteById(id: String) {
    driver.execute(-1_305_466_590, """DELETE FROM TransactionEntity WHERE id = ?""", 1) {
          bindString(0, id)
        }.await()
    notifyQueries(-1_305_466_590) { emit ->
      emit("TransactionEntity")
    }
  }
}
